<template>
  <div class="recharge-result">
    <p><Icon type="ios-checkmark-circle-outline" class="text-primary" /> {{ resultSuccess || 0 }}</p>
    <p><Icon type="ios-alert-outline" class="text-danger" /> {{ resultFail || 0 }}</p>
  </div>
</template>
<script>
export default {
  name: 'RechargeResult',
  props: {
    resultFail: {
      type: Number
    },
    resultSuccess: {
      type: Number
    }
  }
}
</script>
